module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    ref: "sfStatsRef",
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#sf-stats"
    }
  }, [_vm._v("Scheduled Function Stats")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active show",
    attrs: {
      "id": "query-visualizer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartType),
      expression: "chartType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a chart metric")]), _vm._v(" "), _vm._l((_vm.chartTypeDropdown), function(entry) {
    return _c('option', [_vm._v("\n                        " + _vm._s(entry.label) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartSortType),
      expression: "chartSortType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartSortType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a sort type")]), _vm._v(" "), _c('option', [_vm._v("\n                      Ascending\n                    ")]), _vm._v(" "), _c('option', [_vm._v("\n                      Descending\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chartResultSetSize),
      expression: "chartResultSetSize"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chartResultSetSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select a number of results")]), _vm._v(" "), _vm._l((_vm.chartResultSetSizes), function(i) {
    return _c('option', [_vm._v("\n                      " + _vm._s(i) + "\n                    ")])
  })], 2)])])])]), _vm._v(" "), (_vm.chartData) ? _c('div', [_c('pie-chart', {
    attrs: {
      "chartData": _vm.chartData,
      "options": {
        responsive: true,
        maintainAspectRatio: true
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, _vm._l((_vm.chartQueries), function(entry) {
    return (_vm.chartData) ? _c('div', [_c('pre', {
      directives: [{
        name: "highlightjs",
        rawName: "v-highlightjs",
        value: (entry),
        expression: "entry"
      }]
    }, [_c('code', {
      staticClass: "sql"
    })])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "query-stats"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.statsLoading) ? _c('div', [_c('strong', [_vm._v("Results are loading ...")]), _vm._v(" This is a heavy query and can take some time to process please be patient.\n            ")]) : _c('div', [(_vm.rows.length > 0) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'mean_time',
          type: 'desc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    on: {
      "on-row-click": _vm.onClickFn
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'query') ? _c('span', [_vm._v(_vm._s(props.row.query))]) : _vm._e(), _vm._v(" "), (props.column.field == 'calls') ? _c('span', [_vm._v(_vm._s(props.row.calls))]) : _vm._e(), _vm._v(" "), (props.column.field == 'total_time') ? _c('span', [_vm._v(_vm._s(props.row.total_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'min_time') ? _c('span', [_vm._v(_vm._s(props.row.min_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'max_time') ? _c('span', [_vm._v(_vm._s(props.row.max_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'mean_time') ? _c('span', [_vm._v(_vm._s(props.row.mean_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'stddev_time') ? _c('span', [_vm._v(_vm._s(props.row.stddev_time))]) : _vm._e(), _vm._v(" "), (props.column.field == 'rows') ? _c('span', [_vm._v(_vm._s(props.row.rows))]) : _vm._e()]
      }
    }], null, false, 188718182)
  })], 1) : _c('div', [_c('strong', [_vm._v("No Results found!")]), _vm._v(" No recently PG stats could be found.\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "sf-stats"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('loading', {
    attrs: {
      "active": _vm.sfLoading
    },
    on: {
      "update:active": function($event) {
        _vm.sfLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.sfLoading) ? _c('div', [_c('strong', [_vm._v("Results are loading ...")]), _vm._v(" This is a heavy query and can take some time to process please be patient.\n              ")]) : _c('div', [(_vm.functionResults.length > 0) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "title": "Processed Scheduled Functions",
      "columns": _vm.functionColumns,
      "rows": _vm.functionResults,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'started',
          type: 'desc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "styleClass": "vgt-table striped bordered table-hover"
    }
  })], 1) : _c('div', [_c('strong', [_vm._v("No Results found!")]), _vm._v(" No recently processed scheduled function stats cound be found.\n                ")])])], 1)])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.modalShowDetail,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "large": ""
    },
    on: {
      "update:show": function($event) {
        _vm.modalShowDetail = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Query Pattern Detail\n      ")])]), _vm._v(" "), (_vm.selectedQuery) ? _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs",
      value: (_vm.selectedQuery.query),
      expression: "selectedQuery.query"
    }]
  }, [_c('code', {
    staticClass: "sql"
  })]), _vm._v(" "), _c('form', [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Number of Calls")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.calls),
      expression: "selectedQuery.calls"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.calls)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "calls", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Total Time spend processing")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.total_time),
      expression: "selectedQuery.total_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.total_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "total_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Minimum Time query has lasted")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.min_time),
      expression: "selectedQuery.min_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.min_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "min_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Maximum Time query has lasted")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.max_time),
      expression: "selectedQuery.max_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.max_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "max_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Mean Time spend processing query")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.mean_time),
      expression: "selectedQuery.mean_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.mean_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "mean_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Standard deviation of time processing query")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.stddev_time),
      expression: "selectedQuery.stddev_time"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.stddev_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "stddev_time", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_vm._v("Total Rows retrieved or affected by query")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedQuery.rows),
      expression: "selectedQuery.rows"
    }],
    staticClass: "form-control col-2",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.selectedQuery.rows)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedQuery, "rows", $event.target.value)
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModalShowDetail
    }
  }, [_vm._v("Close")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/home"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#/apps"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("View")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "href": "#query-visualizer"
    }
  }, [_vm._v("Query Visualizer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#query-stats"
    }
  }, [_vm._v("Query Stats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Chart Metric\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sort\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Number of results\n                  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ecd72df","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppView.vue
// module id = 587
// module chunks = 2